import { render, staticRenderFns } from "./podIndex.vue?vue&type=template&id=3ab06c0f&"
import script from "./podIndex.vue?vue&type=script&lang=js&"
export * from "./podIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports